'use client';
import { ListboxSection } from '../listbox/listbox-section.component.js';

const MenuSection = ListboxSection;

export { MenuSection };
